/**
 * Date/time formatting utility - Australia/Melbourne timezone
 * All dates across the app should use these functions.
 */

const TIMEZONE = 'Australia/Melbourne';
const LOCALE = 'en-AU';

export const formatDate = (dateStr, options = {}) => {
  if (!dateStr) return '';
  try {
    const date = new Date(dateStr);
    return date.toLocaleDateString(LOCALE, {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      timeZone: TIMEZONE,
      ...options,
    });
  } catch {
    return dateStr;
  }
};

export const formatDateTime = (dateStr, options = {}) => {
  if (!dateStr) return '';
  try {
    const date = new Date(dateStr);
    return date.toLocaleString(LOCALE, {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      timeZone: TIMEZONE,
      ...options,
    });
  } catch {
    return dateStr;
  }
};

export const formatTime = (dateStr, options = {}) => {
  if (!dateStr) return '';
  try {
    const date = new Date(dateStr);
    return date.toLocaleTimeString(LOCALE, {
      hour: '2-digit',
      minute: '2-digit',
      timeZone: TIMEZONE,
      ...options,
    });
  } catch {
    return dateStr;
  }
};

export const formatShortDate = (dateStr) => {
  if (!dateStr) return '';
  try {
    const date = new Date(dateStr);
    return date.toLocaleDateString(LOCALE, {
      day: '2-digit',
      month: 'short',
      timeZone: TIMEZONE,
    });
  } catch {
    return dateStr;
  }
};

export const formatRelative = (dateStr) => {
  if (!dateStr) return '';
  try {
    const date = new Date(dateStr);
    const now = new Date();
    const diff = now - date;
    const minutes = Math.floor(diff / 60000);
    const hours = Math.floor(diff / 3600000);
    const days = Math.floor(diff / 86400000);

    if (minutes < 1) return 'Just now';
    if (minutes < 60) return `${minutes}m ago`;
    if (hours < 24) return `${hours}h ago`;
    if (days < 7) return `${days}d ago`;
    return formatDate(dateStr);
  } catch {
    return dateStr;
  }
};

export const getMelbourneToday = () => {
  const now = new Date();
  const melb = new Date(now.toLocaleString('en-US', { timeZone: TIMEZONE }));
  return melb.getFullYear() + '-' +
    String(melb.getMonth() + 1).padStart(2, '0') + '-' +
    String(melb.getDate()).padStart(2, '0');
};
